import React, { useCallback } from 'react';
import classNames from 'classnames';
import { IconButton } from './buttons/IconButton';

export interface IHeaderPanelActionProps extends React.HTMLProps<HTMLLIElement> {
  iconClassName: string;
  onClick: () => void;
}

function getActionClasses(className?: string) {
  return classNames(`dp-header-panel__action`, className);
}

/**
 * Custom action which can be added to the header of header panel. Will be shown on hover.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function HeaderPanelAction({
  onClick,
  className,
  title,
  iconClassName,
  ...htmlProperties
}: IHeaderPanelActionProps) {
  const handleClick = useCallback(
    (e: React.MouseEvent<Element>) => {
      e.stopPropagation();
      onClick();
    },
    [onClick]
  );

  return (
    <li {...htmlProperties}>
      <IconButton
        onClick={handleClick}
        className={getActionClasses(className)}
        iconClassName={iconClassName}
        iconSize="small"
        title={title}
      />
    </li>
  );
}
